import { isMasterEnv, isReleaseEnv } from '@hlj/hlj-utils'
import { action, computed, observable } from 'mobx'
import { message as antdMessage } from 'hljd'
import Api from '@api/kong_kong/ControlBoard'
import sha1 from 'sha1'
import { HLJ_STATISTIC } from '@util'
import {
  GROUP_PAP,
  HOST_PAP,
  liveLinkMicrophoneStatus,
  livingNetStatus,
  MSG_CASH_PACKAGE,
  MSG_COUPON,
  MSG_IMG_AND_TEXT,
  MSG_INTENT_CONFIG,
  USER_PAP
} from '../constant'

export default class {
  channel_id = '' // 通道id
  live_role = '3' // 1主持人 2嘉宾用户 3普通用户
  timer = null
  @observable chatRoomList = [] // 大家说
  @observable liveList = [] // 主播说
  @observable liveNotice = '' // 直播公告
  @observable chatMsg = '' // 聊天文本框
  @observable chatImages = [] // 聊天图片
  @observable couponModalVisable = false // 优惠券弹框
  @observable cashPackageModalVisible = false // 红包弹框
  @observable coupons = [] // 可选优惠券
  @observable cashPackages = [] // 可选红包
  @observable prohibitUsers = [] // 禁言用户
  @observable hostId = '' // 主播id

  initData = id => {
    this.channel_id = id
    // this.initSocket()
    this.getCoupons()
    this.getCashPackage()
    this.getLiveNotice()
    this.getProhibitUser()
  }

  // 主播信息
  initHost = host => {
    this.hostId = host.hostId
  }

  @computed
  get prohibitUserIds() {
    return this.prohibitUsers.map(item => item.user_info.id)
  }

  @action
  handleWSData = resp => {
    const { msg_type, data = {} } = resp
    const { message } = data
    console.log('chat_ws_data', data)
    // 消息处理逻辑
    if (msg_type == 2) {
      const { chat_room_list = [], live_list = [] } = message || {}
      if (chat_room_list) {
        const removeIds = chat_room_list
          .filter(item => item.deleted)
          .map(item => item.id)
        const newRoomList = chat_room_list.filter(
          item =>
            !item.deleted &&
            !liveLinkMicrophoneStatus.includes(item.msg_kind) &&
            item.msg_kind != livingNetStatus
        )
        this.chatRoomList = this.chatRoomList.filter(
          item => removeIds.indexOf(item.id) == -1
        )
        this.chatRoomList = [...newRoomList, ...this.chatRoomList]
      }
      if (live_list) {
        const removeIds = live_list
          .filter(item => item.deleted)
          .map(item => item.id)
        // 新的消息list, 排除已删除的消息和公告（10）
        const newLiveList = live_list.filter(
          item =>
            !item.deleted &&
            item.msg_kind != 10 &&
            !liveLinkMicrophoneStatus.includes(item.msg_kind) &&
            item.msg_kind != livingNetStatus &&
            item.msg_kind != MSG_INTENT_CONFIG
        )
        this.liveList = this.liveList.filter(
          item => removeIds.indexOf(item.id) == -1
        )
        this.liveList = [...newLiveList, ...this.liveList]
        // 通告消息
        const notice = live_list.find(
          item => !item.deleted && item.msg_kind == 10
        )
        if (notice) {
          const noticeContent = JSON.parse(notice.content || '{}') //容错处理
          this.liveNotice = noticeContent.text
        }
      }
    }
  }

  initSocket = () => {
    const ws = new WebSocket(
      `${this.getWebSocketUrl().webSocketUrl}?channel_id=${
        this.channel_id
      }&live_role=${this.live_role}`
    )
    this.ws = ws
    ws.onopen = e => {
      console.log('连接已打开')
    }

    ws.onmessage = evt => {
      const resp = JSON.parse(evt.data)
      const { msg_type, data = {} } = resp
      const { message } = data
      console.log('接收消息', resp)

      // 心跳
      if (msg_type == 9) {
        const msg = {
          msg_type: 10
        }
        ws.send(JSON.stringify(msg))
      }

      // 消息
      if (msg_type == 2) {
        const { chat_room_list = [], live_list = [] } = message || {}
        if (chat_room_list) {
          const removeIds = chat_room_list
            .filter(item => item.deleted)
            .map(item => item.id)
          const newRoomList = chat_room_list.filter(item => !item.deleted)
          this.chatRoomList = this.chatRoomList.filter(
            item => removeIds.indexOf(item.id) == -1
          )
          this.chatRoomList = [...newRoomList, ...this.chatRoomList]
        }
        if (live_list) {
          const removeIds = live_list
            .filter(item => item.deleted)
            .map(item => item.id)
          const newLiveList = live_list.filter(
            item => !item.deleted && item.msg_kind != 10
          ) // 排除已删除的消息和公告（10）
          this.liveList = this.liveList.filter(
            item => removeIds.indexOf(item.id) == -1
          )
          this.liveList = [...newLiveList, ...this.liveList]
          // 通告消息
          const notice = live_list.find(
            item => !item.deleted && item.msg_kind == 10
          )
          if (notice) {
            const noticeContent = JSON.parse(notice.content)
            this.liveNotice = noticeContent.text
          }
        }
      }
    }

    ws.onerror = evt => {
      console.log('连接错误', evt)
    }

    ws.onclose = evt => {
      console.log('连接已断开', evt)
      // message.warn('连接已断开, 正在尝试重新连接～')
      // this.socket_open = false
      // this.reconnect()
    }
  }

  getWebSocketUrl = () => {
    let webSocketUrl = ''
    let url = ''

    if (isMasterEnv()) {
      url = 'https://message.hunliji.com:5051/chat'
      webSocketUrl = 'wss://message.hunliji.com:5051/chat'
    } else if (isReleaseEnv()) {
      url = '//message.hunliji.com:5055/chat'

      webSocketUrl = `${
        window.location.protocol.indexOf('https') > -1 ? 'wss' : 'ws'
      }://message.hunliji.com:5055/chat`
    } else {
      url = 'http://test.hunliji.com:5050'
      webSocketUrl = 'ws://test.hunliji.com:5050/chat'
    }
    return {
      webSocketUrl,
      domain: url
    }
  }

  // 获取禁言用户
  getProhibitUser = async () => {
    this.destroyTimer()
    const { data } = await Api.chatHistory({
      channel_id: this.channel_id,
      prohibit_user_msg: 1,
      per_page: 500
    })

    this.prohibitUsers = data.list || []

    this.timer = setTimeout(() => {
      this.getProhibitUser()
    }, 5000)
  }

  // 获取直播通告
  getLiveNotice = async () => {
    const { data, RetCode } = await Api.chatHistory({
      channel_id: this.channel_id,
      msg_kind: 10,
      no_stick: 1,
      page: 1,
      pagination: 1,
      per_page: 1,
      room_type: HOST_PAP
    })

    if (RetCode === 0) {
      const notice = data.list && data.list[0] ? data.list[0] : undefined
      if (notice) {
        const noticeContent = JSON.parse(notice.content || '{}')
        this.liveNotice = noticeContent.text
      }
    }
  }

  // 获取更多主播说
  getMoreLiveList = async room_type => {
    let last_id = ''
    if (this.liveList && this.liveList.length > 0 && room_type == HOST_PAP) {
      const index = this.liveList.length - 1
      last_id = this.liveList[index].id
    }

    if (
      this.chatRoomList &&
      this.chatRoomList.length > 0 &&
      room_type == GROUP_PAP
    ) {
      const index = this.chatRoomList.length - 1
      last_id = this.chatRoomList[index].id
    }

    const { data, RetCode } = await Api.chatHistory({
      channel_id: this.channel_id,
      room_type: room_type,
      no_stick: 1,
      per_page: 20,
      last_id
    })

    if (RetCode === 0) {
      if (room_type == HOST_PAP) {
        this.liveList = this.liveList.concat(data.list)
      } else if (room_type == GROUP_PAP) {
        this.chatRoomList = this.chatRoomList.concat(data.list)
      }
    }
  }

  changeLiveNotice = e => {
    this.liveNotice = e.target.value
  }

  // 修改直播通告
  submitLiveNotice = async () => {
    const { RetCode } = await Api.chatAddMsg({
      channel_id: this.channel_id,
      content: JSON.stringify({
        text: this.liveNotice,
        medias: [],
        images: []
      }),
      host_id: this.hostId,
      sign: sha1(`key=hunliji2016&host_id=${this.hostId}`),
      msg_kind: '10'
    })

    if (RetCode === 0) {
      antdMessage.success('设置直播通告成功！')
    }
  }

  // 发送直播消息
  sendChatMsg = async () => {
    if (!this.chatMsg && this.chatImages.length == 0) {
      antdMessage.error('消息不能为空')
      return
    }

    const medias = this.chatImages.map(({ path, width, height }) => ({
      media: {
        type: 1,
        photo: {
          image_path: path,
          width,
          height
        }
      }
    }))
    const { RetCode } = await Api.chatAddMsg({
      channel_id: this.channel_id,
      content: JSON.stringify({
        text: this.chatMsg,
        medias,
        images: []
      }),
      host_id: this.hostId,
      sign: sha1(`key=hunliji2016&host_id=${this.hostId}`),
      msg_kind: MSG_IMG_AND_TEXT
    })

    if (RetCode === 0) {
      this.chatMsg = ''
      this.chatImages = []
    }

    HLJ_STATISTIC({
      page_name: '视频直播/直播中控台',
      element_tag: 'live_talking_send_btn'
    })
  }

  // 删除直播信息
  chatDelMsg = id => async () => {
    const { success } = await Api.chatDelMsg({
      host_id: this.hostId,
      sign: sha1(`key=hunliji2016&host_id=${this.hostId}`),
      id
    })
    if (success) {
      this.liveList = this.liveList.filter(item => item.id !== id)
    }
  }

  // 修改直播信息
  changeChatMsg = e => {
    this.chatMsg = e.target.value
  }

  // 修改优惠券弹框
  @action
  changeCouponModalVisable = () => {
    this.couponModalVisable = !this.couponModalVisable
  }

  // 修改红包弹框
  @action
  changeCashModalVisible = () => {
    this.cashPackageModalVisible = !this.cashPackageModalVisible
  }

  // 获取可用优惠券
  @action
  getCoupons = async () => {
    const { RetCode, data } = await Api.liveChannelCouponContent()
    if (RetCode === 0) {
      this.coupons = data
    }
  }

  // 获取可用红包
  @action
  getCashPackage = async () => {
    const { data, success } = await Api.liveChannelCashPackageContent({
      channel_id: this.channel_id
    })
    if (success) {
      this.cashPackages = data.list || []
    }
  }

  @action
  sendCoupon = item => async () => {
    const { RetCode } = await Api.chatAddMsg({
      channel_id: this.channel_id,
      content: JSON.stringify(item),
      host_id: this.hostId,
      sign: sha1(`key=hunliji2016&host_id=${this.hostId}`),
      msg_kind: MSG_COUPON
    })

    if (RetCode === 0) {
      this.changeCouponModalVisable()
    }
  }

  @action
  sendCashPackage = item => async () => {
    const { success } = await Api.chatAddMsg({
      channel_id: this.channel_id, //通道id
      content: JSON.stringify(item), //内容
      host_id: this.hostId, //主播id
      sign: sha1(`key=hunliji2016&host_id=${this.hostId}`), //签名
      msg_kind: MSG_CASH_PACKAGE //内容类型
    })
    if (success) {
      this.changeCashModalVisible()
    }
  }

  @action
  onCliped = (file, path, img) => {
    if (this.chatImages.length >= 9) {
      antdMessage.error('最多上传9张图片')
      return
    }
    img.path = path
    this.chatImages.push(img)
  }

  @action
  deleteChatImg = index => () => {
    this.chatImages.splice(index, 1)
  }

  @action
  forbiddenWords = (userId, status) => async () => {
    const { RetCode } = await Api.forbiddenWords({
      id: this.channel_id,
      userId: userId,
      type: status // 1禁止 2非禁止
    })

    if (RetCode === 0) {
      this.getProhibitUser()
    }
  }

  @action
  setLiveListRef = liveListRef => {
    if (liveListRef) {
      liveListRef.onscroll = () => {
        if (liveListRef.scrollHeight - liveListRef.scrollTop == 500) {
          this.getMoreLiveList(HOST_PAP)
        }
      }
    }
  }

  @action
  setRoomListRef = roomListRef => {
    if (roomListRef) {
      roomListRef.onscroll = () => {
        if (roomListRef.scrollHeight - roomListRef.scrollTop == 500) {
          this.getMoreLiveList(GROUP_PAP)
        }
      }
    }
  }
  // 切换至禁言用户时 请求数据
  onTabChange = key => {
    if (key == USER_PAP) {
      this.getProhibitUser()
    }
  }

  destroyTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
